import { render, staticRenderFns } from "./CatalogoDigitalSettingsTab.vue?vue&type=template&id=cb382a60&scoped=true"
import script from "./CatalogoDigitalSettingsTab.vue?vue&type=script&lang=js"
export * from "./CatalogoDigitalSettingsTab.vue?vue&type=script&lang=js"
import style0 from "./CatalogoDigitalSettingsTab.vue?vue&type=style&index=0&id=cb382a60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb382a60",
  null
  
)

export default component.exports